import React from "react";
import { Routes, Route } from "react-router-dom";

// Landing
import Home from "./Landing/Pages/Home";

// Auth
import Login from "./Auth/Login/Login";

function App () {

  return (
    <React.Fragment>

      <Routes>

        <Route path="/" element={<Home/>} />
        <Route path="/Login" element={<Login/>} />

      </Routes>
      
    </React.Fragment>
  )
}

export default App